import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Animations } from '../../Types/allTypes';
import Animation from './Animation';

const NotFound: React.FC = () => {
    const navigate = useNavigate();
    return (
        <Container
            maxWidth="sm"
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                overflow: 'hidden'
            }}
        >
            <Animation size={{width: 200, height: 200}} animationData={Animations.NOT_FOUND} />
            <Typography variant="h4" color="error">
                404 - Page Not Found
            </Typography>
            <Typography variant="body1" style={{ margin: '20px 0' }}>
                Sorry, the page you are looking for does not exist.
            </Typography>
            <Button
                variant="contained"
                onClick={() => navigate(-1)}
                color="primary"
            >
                Go Back
            </Button>
        </Container>
    );
};

export default NotFound;
